import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const Time = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const type = useWatch({ control, name: `suspiciousActivityInfo.cyberEventIndicators.${index as 0}.type` })

  return (
    <Controller
      name={`suspiciousActivityInfo.cyberEventIndicators.${index as 0}.time`}
      control={control}
      render={({ field }) => (
        <FF2
          label="Timestamp (UTC)"
          field={field}
          input={(props) => (
            <TextInput
              {...props}
              disabled={!(type && ['Command and control IP address', 'Suspicious IP address'].includes(type))}
            />
          )}
        />
      )}
    />
  )
}
